const normalizePath = (pathname = '') =>
  pathname
    .split('/')
    .filter((part) => part.length)
    .join('/');

export default normalizePath;
